import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useAppSelector } from '../../../store/hooks';
import { selectCities } from '../../../store/slices/mapSlice';

import DropDownSelect, { DropDownColorTheme } from '../../dropDownSelect';
import { MarketSearchOptions } from '../tabs/marketDashboard';
import { debounce } from '../../../utilities/generalHelpers';

const SEARCH_SELECT_WIDTH = '175px';

const RealEstateMarketGeneralFilters = ({ filters, onChange }) => {
    const [searchFilters, setSearchFilters] = useState({
        [MarketSearchOptions.Location]: filters[MarketSearchOptions.Location],
        [MarketSearchOptions.MinLotSize]: filters[MarketSearchOptions.MinLotSize],
        [MarketSearchOptions.MaxLotSize]: filters[MarketSearchOptions.MaxLotSize],

        [MarketSearchOptions.MinBldSize]: filters[MarketSearchOptions.MinBldSize],
        [MarketSearchOptions.MaxBldSize]: filters[MarketSearchOptions.MaxBldSize],
    });
    const filterRef = useRef(searchFilters);
    const cities = useAppSelector(selectCities);

    useEffect(() => {
        filterRef.current = searchFilters;
    }, [searchFilters]);
    const debouncedOnChange = useMemo(
        () =>
            debounce(() => {
                onChange(filterRef.current); // always reads the latest value
            }, 800),
        [],
    );

    useEffect(() => {
        return () => debouncedOnChange.cancel();
    }, []);

    const handleSelectLocation = (selected) => {
        const updatedFilters = {
            ...searchFilters,
            [MarketSearchOptions.Location]: selected || 'All Locations',
        };
        setSearchFilters(updatedFilters);
        onChange(updatedFilters);
    };

    const handleInputChange = (field, value) => {
        setSearchFilters((prev) => ({ ...prev, [field]: value }));
        debouncedOnChange();
    };

    const renderEditableNumber = (field, label, value, max) => (
        <div className="realEstateFilterInput">
            <div className="text-white">{label}:</div>
            <div>
                <input
                    max={max}
                    min="0"
                    value={value}
                    type="number"
                    onChange={(e) => handleInputChange(field, e.target.value)}
                    className="text-end border-0 rounded"
                />
            </div>
        </div>
    );

    return (
        <div className="d-flex flex-column flex-lg-row gap-3 justify-content-xs-start align-items-lg-center">
            <div style={{ width: SEARCH_SELECT_WIDTH }}>
                <DropDownSelect
                    options={[...cities]}
                    selected={searchFilters[MarketSearchOptions.Location]}
                    onSelect={handleSelectLocation}
                    colorTheme={DropDownColorTheme.dark}
                    label="All Locations"
                />
            </div>
            {renderEditableNumber(
                MarketSearchOptions.MinLotSize,
                'Minimum Lot Size',
                searchFilters[MarketSearchOptions.MinLotSize],
                '100000',
            )}
            {renderEditableNumber(
                MarketSearchOptions.MaxLotSize,
                'Maximum Lot Size',
                searchFilters[MarketSearchOptions.MaxLotSize],
                '100000',
            )}
            {renderEditableNumber(
                MarketSearchOptions.MinBldSize,
                'Minimum Building Size',
                searchFilters[MarketSearchOptions.MinBldSize],
                '100000',
            )}
            {renderEditableNumber(
                MarketSearchOptions.MaxBldSize,
                'Maximum Building Size',
                searchFilters[MarketSearchOptions.MaxBldSize],
                '100000',
            )}
        </div>
    );
};

export default RealEstateMarketGeneralFilters;
